export default __webpack_public_path__ + "src/assets/seedtag_logo.png";